import { render, staticRenderFns } from "./LandSales.vue?vue&type=template&id=3a1b40d8"
import script from "./LandSales.vue?vue&type=script&lang=js"
export * from "./LandSales.vue?vue&type=script&lang=js"
import style0 from "./LandSales.vue?vue&type=style&index=0&id=3a1b40d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports